import { readPref, writePref } from "../kit/storage.ts";
import { parseTutorial, TUTORIAL_PREF, TUTORIAL_STEPS, type TutorialSave } from "./tutorial-model.ts";

type Listener = (save: TutorialSave, previous: TutorialSave) => void;
const listeners = new Set<Listener>();

/** O tutorial guardado neste navegador. */
export const loadTutorial = (): TutorialSave => parseTutorial(readPref(TUTORIAL_PREF, ""));

/** Concluído ou desligado: é o que a conta guarda (F34). */
export const tutorialFinished = (save: TutorialSave): boolean => !save.enabled || TUTORIAL_STEPS.every((s) => save.done.includes(s.id));

/**
 * Único ponto de escrita do tutorial (menu, Opções e a partida): grava e avisa quem acompanha (a
 * conta espelha "concluído" na API).
 */
export function saveTutorial(save: TutorialSave): void {
  const previous = loadTutorial();
  writePref(TUTORIAL_PREF, JSON.stringify(save));
  for (const listener of listeners) listener(save, previous);
}

export function onTutorialSaved(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
